import { z } from 'zod';
import { pageSchema } from './Page.js';

const settingsSchema = z.object({
  enabledFeatures: z.object({
    richTextFormating: z.boolean().default(false),
    wiris: z.boolean().default(false)
  }),
  crediting: z.string().nullish().default(null),
  speechLanguage: z.enum(["none", "da", "en", "fr", "de", "es"]).default("none"),
  secondarySpeechLanguage: z.enum(["none", "da", "en", "fr", "de", "es"]).optional(),
  latexSpeechLanguage: z.enum(["none", "mathematical", "scientific"]).default("none")
});
const iArkDataSchema = z.object({
  version: z.number().default(2),
  lastEditorVersion: z.number().default(2),
  originalVersion: z.number().default(1),
  pages: z.array(pageSchema).default([]),
  style: z.object({
    colors: z.object({
      textColor: z.string(),
      inputTextColor: z.string()
    })
  }),
  settings: settingsSchema
});

export { iArkDataSchema };
//# sourceMappingURL=ComponentData.js.map
